import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private renderer: Renderer2;
  private isRhetorikThemeActive: boolean = false;
  private themeStateSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.isRhetorikThemeActive);

  constructor(private rendererFactory: RendererFactory2) {
    this.renderer = this.rendererFactory.createRenderer(document, null);
    this.loadThemeState(); // Загрузка сохраненного состояния темы при инициализации
    if (this.isRhetorikThemeActive) {
      this.renderer.addClass(document.body, 'rhetorik-theme'); // Добавляем класс, если тема активна
    }
  }

  activateTheme(themeClass: string) {
    console.log(this.renderer)
    this.renderer.addClass(document.body, themeClass);
    this.isRhetorikThemeActive = true;
    this.themeStateSubject.next(this.isRhetorikThemeActive);  // Уведомляем подписчиков
    this.saveThemeState(); // Сохранение состояния в localStorage
  }

  deactivateTheme(themeClass: string) {
    this.renderer.removeClass(document.body, themeClass);
    this.isRhetorikThemeActive = false;
    this.themeStateSubject.next(this.isRhetorikThemeActive);  // Уведомляем подписчиков
    this.saveThemeState(); // Сохранение состояния в localStorage
  }

  isRhetorikTheme(): boolean {
    return this.isRhetorikThemeActive;
  }

  getThemeState(): Observable<boolean> {
    return this.themeStateSubject.asObservable();  // Возвращаем поток для подписки
  }

  private saveThemeState() {
    localStorage.setItem('isRhetorikThemeActive', JSON.stringify(this.isRhetorikThemeActive));
  }

  private loadThemeState() {
    const savedState = localStorage.getItem('isRhetorikThemeActive');
    if (savedState !== null) {
      this.isRhetorikThemeActive = JSON.parse(savedState);
      this.themeStateSubject.next(this.isRhetorikThemeActive); // Уведомляем подписчиков текущим состоянием
    }
  }
}
